import { css } from "@emotion/css";
interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  isSelected?: boolean;
  isDisabled?: boolean;
  isFocusVisible?: boolean;
  isCard?: boolean;
}

export function RadioControl(props: Props) {
  const { isSelected, isDisabled, isFocusVisible } = props;

  return (
    <div className={styles.container}>
      <div
        className={css(
          styles.checkbox,
          {
            borderColor: "var(--border-input)",
            "&:hover": {
              borderColor: "var(--border-input-hover)",
            },
          },
          isSelected && {
            borderColor: "var(--background-selected-strong)",
            "&:hover": {
              borderColor: "var(--background-selected-strong)",
            },
          },
          isDisabled && {
            cursor: "not-allowed",
            borderColor: "var(--background-selected-disabled)",
            "&:hover": {
              borderColor: "var(--background-selected-disabled)",
            },
          },
          isFocusVisible && {
            boxShadow: "var(--focus-action)",
          }
        )}
      >
        {isSelected && (
          <div
            className={css(
              styles.dot,
              {
                backgroundColor: "var(--background-selected-strong)",
              },
              isDisabled && {
                backgroundColor: "var(--background-selected-disabled)",
              }
            )}
          />
        )}
      </div>
    </div>
  );
}

const styles = {
  container: css({
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    height: 20,
    justifyContent: "center",
    width: 20,
  }),
  checkbox: css({
    alignItems: "center",
    borderRadius: "var(--border-radius-half)",
    borderStyle: "solid",
    borderWidth: 2,
    boxSizing: "border-box",
    cursor: "pointer",
    display: "flex",
    height: 18,
    justifyContent: "center",
    width: 18,
  }),
  dot: css({
    borderRadius: "var(--border-radius-half)",
    height: 8,
    width: 8,
  }),
};
